// extracted by mini-css-extract-plugin
export var colorSquare = "_s9-0";
export var danger = "_s9-5";
export var lightPink = "_s9-8";
export var neutralBlue = "_s9-7";
export var neutralYellow = "_s9-6";
export var normal = "_s9-1";
export var primary = "_s9-2";
export var primaryLight = "_s9-3";
export var solidBlack = "_s9-g";
export var solidGreen = "_s9-b";
export var solidLightBlue = "_s9-d";
export var solidNavy = "_s9-c";
export var solidOrange = "_s9-f";
export var solidPink = "_s9-e";
export var solidRed = "_s9-9";
export var solidYellow = "_s9-a";
export var success = "_s9-4";